import { useManagedListOptions } from "./useManagedListOptions.ts"

export type StatusOption = ReturnType<typeof useManagedListOptions>["options"][number]

/** The company's active Document Status options, shared by every picker so they never drift. */
export function useStatusOptions(enabled = true) {
  return useManagedListOptions("document_status", enabled)
}
